module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-12-332ceaca7560052044cca1436305feca.svg";